import React, {useState} from 'react'
import './certifications.css'

const Certifications = () => {
  return (

    <section className='qualification section' id='edu'>
        <h2 className='section__title'>Licenses & Certifications</h2>
        <span className='section__subtitle'></span>
        <div></div>
        <div className='project__section'>
                <div className='project__content project__content-active'>
                    <div className='project__data'>
                        <div>
                            <h3 className='project__title'>Linear Algebra for Machine Learning and Data Science </h3>
                            <span className='project__subtitle'><i class="uil uil-university"></i>{" "} DeepLearning.AI </span><br/>
                            <span className='project__subtitle'><i class="uil uil-notebooks"></i>{" "} Credential ID G6YGAZJNJP7X 
</span>
                            <div className='project__calender'>
                            <i class="uil uil-calendar-alt"></i>{" "}Issued Sep 2023 

                         </div>
                        </div>

                        <div>
                            <span className='project__rounder'></span>
                            <span className='project__line'></span>
                        </div>
                    </div>

                    <div className='project__data'>
                        <div></div>
                        <div>
                            <span className='project__rounder'></span>
                            <span className='project__line'></span>
                        </div>

                        <div>
                            <h3 className='project__title'> Supervised Machine Learning: Regression and Classification.</h3>
                            <span className='project__subtitle'><i class="uil uil-university"></i>{" "} DeepLearning.AI </span><br/>
                            <span className='project__subtitle'><i class="uil uil-notebooks"></i>{" "} Credential ID  EKLUV6CQHFDL 
</span>
                            <div className='project__calender'>
                            <i class="uil uil-calendar-alt"></i>{" "}Issued Sep 2023 
                            </div>
                            
                        </div>

                        
                    </div>
                    <div className='project__data'>
                        <div>
                            <h3 className='project__title'>AI For Everyone </h3>
                            <span className='project__subtitle'><i class="uil uil-university"></i>{" "} DeepLearning.AI </span><br/>
                            <span className='project__subtitle'><i class="uil uil-notebooks"></i>{" "} Credential ID JLCFGQVXTRMA 
</span>
                            <div className='project__calender'>
                            <i class="uil uil-calendar-alt"></i>{" "}Issued Mar 2023 

                         </div>
                        </div>

                        <div>
                            <span className='project__rounder'></span>
                            <span className='project__line'></span>
                        </div>
                    </div>

                    <div className='project__data'>
                        <div></div>
                        <div>
                            <span className='project__rounder'></span>
                            <span className='project__line'></span>
                        </div>

                        <div>
                            <h3 className='project__title'> C for Everyone: Programming Fundamentals</h3>
                            <span className='project__subtitle'><i class="uil uil-university"></i>{" "}  University of California, Santa Cruz </span><br/>
                            <span className='project__subtitle'><i class="uil uil-notebooks"></i>{" "} Credential ID   QAWML3H6CKBG  
</span>
                            <div className='project__calender'>
                            <i class="uil uil-calendar-alt"></i>{" "}Issued Feb 2023 
                            </div>
                            
                        </div>

                        
                    </div>

                    <div className='project__data'>
                        <div>
                            <h3 className='project__title'>Python Data Structures </h3>
                            <span className='project__subtitle'><i class="uil uil-university"></i>{" "}  University of Michigan </span><br/>
                            <span className='project__subtitle'><i class="uil uil-notebooks"></i>{" "} Credential ID  J9XKY7RAX8WD 
</span>
                            <div className='project__calender'>
                            <i class="uil uil-calendar-alt"></i>{" "}Issued Feb 2023 

                         </div>
                        </div>

                        <div>
                            <span className='project__rounder'></span>
                            <span className='project__line'></span>
                        </div>
                    </div>

                    <div className='project__data'>
                        <div></div>
                        <div>
                            <span className='project__rounder'></span>
                            <span className='project__line'></span>
                        </div>

                        <div>
                            <h3 className='project__title'> Programming for Everybody (Getting Started with Python)</h3>
                            <span className='project__subtitle'><i class="uil uil-university"></i>{" "}   University of Michigan </span><br/>
                            <span className='project__subtitle'><i class="uil uil-notebooks"></i>{" "} Credential ID   TF288AN8XW7J  
</span>
                            <div className='project__calender'>
                            <i class="uil uil-calendar-alt"></i>{" "}Issued Aug 2022 
                            </div>
                            
                        </div>

                        
                    </div>

                </div>

        </div>
        
    </section>
  )
}

export default Certifications